import { GroupChatView, GroupChatViewProps } from "@app/pages/group-chat/GroupChatView";
import { attr, bool, jsonArrayAttr } from "@app/widgets/shared/parseAttr";

export type GroupChatWidgetProps = GroupChatViewProps;

export const parseGroupChatProps = (container: HTMLElement): GroupChatWidgetProps => ({
  heightMode: (attr(container, "data-height-mode", "fullscreen") === "fixed" ? "fixed" : "fullscreen") as "fixed" | "fullscreen",
  height: attr(container, "data-height", "600px"),
  bgColor: attr(container, "data-bg-color", "#ffffff"),
  borderColor: attr(container, "data-border-color", "#f0f0f0"),
  borderRadius: attr(container, "data-border-radius", "8px"),
  conversationIds: jsonArrayAttr(container, "data-conversation-ids", "GroupChatWidget"),
  showSidebar: bool(container, "data-show-sidebar", true),
  sidebarPosition: (attr(container, "data-sidebar-position", "left") === "right" ? "right" : "left") as "left" | "right",
  sidebarWidth: attr(container, "data-sidebar-width", "280px"),
  sidebarBgColor: attr(container, "data-sidebar-bg-color", "#fafafa"),
  sidebarTextColor: attr(container, "data-sidebar-text-color"),
  itemHoverBgColor: attr(container, "data-item-hover-bg-color", "#f5f5f5"),
  itemActiveBgColor: attr(container, "data-item-active-bg-color", "#e6f4ff"),
  itemBorderColor: attr(container, "data-item-border-color", "#f5f5f5"),
  showHeader: bool(container, "data-show-header", true),
  topicsBgColor: attr(container, "data-topics-bg-color"),
  topicColor: attr(container, "data-topic-color"),
  topicActiveColor: attr(container, "data-topic-active-color"),
  topicFontSize: attr(container, "data-topic-font-size", "14px"),
  messagesBgColor: attr(container, "data-messages-bg-color", "#fcfcfc"),
  bubbleInBgColor: attr(container, "data-bubble-in-bg-color", "#f1f1f1"),
  bubbleInTextColor: attr(container, "data-bubble-in-text-color"),
  bubbleOutBgColor: attr(container, "data-bubble-out-bg-color", "#e6f4ff"),
  bubbleOutTextColor: attr(container, "data-bubble-out-text-color"),
  bubbleBorderRadius: attr(container, "data-bubble-border-radius", "4px"),
  bubbleFontSize: attr(container, "data-bubble-font-size", "13px"),
  messageFontFamily: attr(container, "data-message-font-family"),
  showMessageAuthor: bool(container, "data-show-message-author", true),
  showMessageDate: bool(container, "data-show-message-date", true),
  showMessageAvatar: bool(container, "data-show-message-avatar", true),
  dayBgColor: attr(container, "data-day-bg-color"),
  dayTextColor: attr(container, "data-day-text-color"),
  dayFontSize: attr(container, "data-day-font-size", "13px"),
  dayBorderRadius: attr(container, "data-day-border-radius", "6px"),
  dayLineColor: attr(container, "data-day-line-color"),
  metaColor: attr(container, "data-meta-color"),
  metaFontSize: attr(container, "data-meta-font-size", "11px"),
  authorColor: attr(container, "data-author-color"),
  authorFontWeight: attr(container, "data-author-font-weight", "700"),
  badgeColor: attr(container, "data-badge-color", "#ff4d4f"),
  badgeTextColor: attr(container, "data-badge-text-color", "#ffffff"),
  composeBgColor: attr(container, "data-compose-bg-color"),
  composeInputBgColor: attr(container, "data-compose-input-bg-color"),
  composeIconColor: attr(container, "data-compose-icon-color"),
  composeIconSize: attr(container, "data-compose-icon-size", "16px"),
  composeTextColor: attr(container, "data-compose-text-color"),
  composeFontSize: attr(container, "data-compose-font-size", "14px"),
  composePlaceholderColor: attr(container, "data-compose-placeholder-color"),
  composeBorderColor: attr(container, "data-compose-border-color"),
  composeBorderWidth: attr(container, "data-compose-border-width"),
  composeBorderRadius: attr(container, "data-compose-border-radius"),
  composeBorderStyle: attr(container, "data-compose-border-style"),
  borderWidth: attr(container, "data-border-width"),
  borderStyle: attr(container, "data-border-style"),
  fontFamily: attr(container, "data-font-family"),
  itemBorderWidth: attr(container, "data-item-border-width"),
  itemBorderStyle: attr(container, "data-item-border-style"),
  bubbleBorderColor: attr(container, "data-bubble-border-color"),
  bubbleBorderWidth: attr(container, "data-bubble-border-width"),
  bubbleBorderStyle: attr(container, "data-bubble-border-style"),
  dayBorderColor: attr(container, "data-day-border-color"),
  dayBorderWidth: attr(container, "data-day-border-width"),
  dayBorderStyle: attr(container, "data-day-border-style"),
  emptyTextColor: attr(container, "data-empty-text-color", "#8c8c8c"),
  conversationsText: attr(container, "data-conversations-text") || undefined,
  emptyConversationsText: attr(container, "data-empty-conversations-text") || undefined,
  emptyMessagesText: attr(container, "data-empty-messages-text") || undefined,
  messagePlaceholderText: attr(container, "data-message-placeholder-text") || undefined,
});

export const GroupChatWidget: React.FC<GroupChatWidgetProps> = (props) => (
  <GroupChatView {...props} />
);
